import produce from "immer";
import { v1 as uuid } from "uuid";
import { CustomizationState } from "../";
import { OptionsConfiguration } from "../../../types/customization/configuration";
import { findPage } from "../../../utils/customization/finders";
import {
  changeOnePagePageDefinition,
  checkAndReplaceInvalidPageDefinitions,
} from "../../../utils/customization/pageDefinition";
import { addNotificationRemovingSameOnes } from "../../../utils/notification";

export interface ChangePagePageDefinitionAction {
  type: "changePagePageDefinition";
  options: OptionsConfiguration[] | undefined;
  pageDefinitionKey: string;
  pageKey: string;
}

export function changePagePageDefinition(
  state: CustomizationState,
  action: ChangePagePageDefinitionAction
): CustomizationState {
  return produce(state, (draftState) => {
    const options = action.options || [];

    const page = findPage(action.pageKey, draftState.content);

    const { hasLoss } = changeOnePagePageDefinition(
      page,
      draftState,
      action.pageDefinitionKey,
      options
    );

    checkAndReplaceInvalidPageDefinitions(draftState, options);

    if (hasLoss) {
      addNotificationRemovingSameOnes(draftState.notifications, {
        code: "KFW-001",
        key: uuid(),
      });
    }
  });
}
